import { useState, useMemo } from "react";

const allCities = [
  { name: "Portland", route: "/cities/portland", tagline: "Oregon's largest city — emergency & expedited passport services", highlights: ["Portland metro coverage", "Serving Beaverton, Gresham, Hillsboro"], badge: "Most Popular", status: "live" },
  { name: "Eugene", route: "/cities/eugene", tagline: "Lane County expedited passport processing", highlights: ["University of Oregon area", "Serving Springfield, Cottage Grove"], badge: "Most Popular", status: "live" },
  { name: "Salem", route: "/cities/salem", tagline: "Marion & Polk County rush passport services", highlights: ["State capital area", "Serving Keizer, Woodburn"], badge: null, status: "live" },
  { name: "Bend", route: "/cities/bend", tagline: "Central Oregon expedited passport hub", highlights: ["Deschutes County coverage", "Serving Redmond, Sisters, Prineville"], badge: null, status: "live" },
  { name: "Medford", route: "/cities/medford", tagline: "Southern Oregon passport courier service", highlights: ["Jackson County coverage", "Serving Ashland, Grants Pass"], badge: null, status: "live" },
  { name: "Corvallis", route: "/cities/corvallis", tagline: "Benton County expedited passport services", highlights: ["Oregon State University area", "Serving Albany, Lebanon"], badge: null, status: "live" },
  { name: "Beaverton", route: "/cities/beaverton", tagline: "Washington County passport processing", highlights: ["Beaverton metro coverage", "Serving Tigard, Tualatin"], badge: null, status: "live" },
  { name: "Hillsboro", route: "/cities/hillsboro", tagline: "Silicon Forest expedited passport services", highlights: ["Washington County coverage", "Serving Cornelius, Forest Grove"], badge: null, status: "live" },
  { name: "Gresham", route: "/cities/gresham", tagline: "East Portland metro passport services", highlights: ["Multnomah County coverage", "Serving Troutdale, Fairview"], badge: null, status: "live" },
  { name: "Lake Oswego", route: "/cities/lake-oswego", tagline: "Clackamas County luxury passport services", highlights: ["Lake Oswego area coverage", "Serving West Linn, Oregon City"], badge: null, status: "live" },
  { name: "Tigard", route: "/cities/tigard", tagline: "Washington County expedited passport processing", highlights: ["Tigard area coverage", "Serving Tualatin, Sherwood"], badge: null, status: "live" },
  { name: "Tualatin", route: "/cities/tualatin", tagline: "South metro passport services", highlights: ["Tualatin area coverage", "Serving Wilsonville, Newberg"], badge: null, status: "live" },
  { name: "Oregon City", route: "/cities/oregon-city", tagline: "Clackamas County passport processing", highlights: ["Historic Oregon City area", "Serving Gladstone, Milwaukie"], badge: null, status: "live" },
  { name: "West Linn", route: "/cities/west-linn", tagline: "Clackamas County expedited passports", highlights: ["West Linn area coverage", "Serving Lake Oswego, Oregon City"], badge: null, status: "live" },
  { name: "Milwaukie", route: "/cities/milwaukie", tagline: "Clackamas County passport services", highlights: ["Milwaukie area coverage", "Serving Sellwood, Oregon City"], badge: null, status: "live" },
  { name: "Happy Valley", route: "/cities/happy-valley", tagline: "Clackamas County expedited passport processing", highlights: ["Happy Valley area coverage", "Serving Clackamas, Damascus"], badge: null, status: "live" },
  { name: "Troutdale", route: "/cities/troutdale", tagline: "Columbia River Gorge passport services", highlights: ["Troutdale area coverage", "Serving Gresham, Wood Village"], badge: null, status: "live" },
  { name: "Forest Grove", route: "/cities/forest-grove", tagline: "Washington County passport processing", highlights: ["Forest Grove area", "Serving Cornelius, Hillsboro"], badge: null, status: "live" },
  { name: "Newberg", route: "/cities/newberg", tagline: "Yamhill County expedited passport services", highlights: ["Newberg area coverage", "Serving Dundee, McMinnville"], badge: null, status: "live" },
  { name: "Wilsonville", route: "/cities/wilsonville", tagline: "Southern Portland metro passport services", highlights: ["Wilsonville area", "Serving Tualatin, Canby"], badge: null, status: "live" },
  { name: "Sherwood", route: "/cities/sherwood", tagline: "Washington County passport processing", highlights: ["Sherwood area coverage", "Serving Tualatin, Newberg"], badge: null, status: "live" },
  { name: "Canby", route: "/cities/canby", tagline: "Clackamas County expedited passports", highlights: ["Canby area coverage", "Serving Molalla, Oregon City"], badge: null, status: "live" },
  { name: "Gladstone", route: "/cities/gladstone", tagline: "Clackamas County emergency & expedited passport services", highlights: ["Gladstone area coverage", "Serving Oregon City, West Linn"], badge: null, status: "live" },
  { name: "Estacada", route: "/cities/estacada", tagline: "Clackamas County rural expedited passport services", highlights: ["Estacada area coverage", "Serving Sandy, Molalla"], badge: null, status: "live" },
  { name: "Sandy", route: "/cities/sandy", tagline: "Mt. Hood gateway emergency passport services", highlights: ["Sandy area coverage", "Serving Estacada, Gresham"], badge: null, status: "live" },
  { name: "Hood River", route: "/cities/hood-river", tagline: "Columbia River Gorge expedited passports", highlights: ["Hood River area coverage", "Serving Cascade Locks, The Dalles"], badge: null, status: "live" },
  { name: "The Dalles", route: "/cities/the-dalles", tagline: "Wasco County emergency & expedited passport services", highlights: ["The Dalles & Columbia River Gorge", "Serving Hood River, Mosier, Maupin"], badge: null, status: "live" },
  { name: "Pendleton", route: "/cities/pendleton", tagline: "Umatilla County expedited passport services", highlights: ["Pendleton & Eastern Oregon coverage", "Serving Hermiston, Milton-Freewater"], badge: null, status: "live" },
  { name: "La Grande", route: "/cities/la-grande", tagline: "Union County emergency passport services", highlights: ["La Grande & Blue Mountains area", "Serving Baker City, Enterprise, Elgin"], badge: null, status: "live" },
  { name: "Ontario", route: "/cities/ontario-or", tagline: "Malheur County expedited passport services", highlights: ["Ontario & Treasure Valley border area", "Serving Nyssa, Payette ID, Nampa ID"], badge: null, status: "live" },
  { name: "Klamath Falls", route: "/cities/klamath-falls", tagline: "Klamath County emergency & expedited passport services", highlights: ["Klamath Basin coverage", "Serving Merrill, Malin, Lakeview"], badge: null, status: "live" },
  { name: "Grants Pass", route: "/cities/grants-pass", tagline: "Josephine County emergency & expedited passport services", highlights: ["Grants Pass & Illinois Valley coverage", "Serving Rogue River, Cave Junction"], badge: null, status: "live" },
  { name: "Ashland", route: "/cities/ashland-or", tagline: "Rogue Valley expedited passport services", highlights: ["Ashland & Jackson County coverage", "Serving Talent, Phoenix, Medford"], badge: null, status: "live" },
  { name: "Roseburg", route: "/cities/roseburg", tagline: "Umpqua Valley emergency & expedited passport services", highlights: ["Douglas County coverage", "Serving Sutherlin, Winston, Myrtle Creek"], badge: null, status: "live" },
  { name: "Albany", route: "/cities/albany-or", tagline: "Linn & Benton County emergency & expedited passport services", highlights: ["Albany & Linn County coverage", "Serving Lebanon, Corvallis, Sweet Home"], badge: null, status: "live" },
  { name: "Lebanon", route: "/cities/lebanon-or", tagline: "Linn County emergency & expedited passport services", highlights: ["Lebanon & east Linn County coverage", "Serving Albany, Sweet Home, Scio"], badge: null, status: "live" },
  { name: "Springfield", route: "/cities/springfield-or", tagline: "Lane County emergency & expedited passport services", highlights: ["Springfield & Lane County coverage", "Serving Eugene, Creswell, Cottage Grove"], badge: null, status: "live" },
  { name: "Coos Bay", route: "/cities/coos-bay", tagline: "Coos County Oregon Coast emergency & expedited passport services", highlights: ["Coos Bay & Oregon Coast coverage", "Serving North Bend, Bandon, Coquille"], badge: null, status: "live" },
  { name: "Astoria", route: "/cities/astoria", tagline: "Clatsop County emergency & expedited passport services", highlights: ["Astoria & Columbia River estuary coverage", "Serving Warrenton, Seaside, Cannon Beach"], badge: null, status: "live" },
  { name: "Seaside", route: "/cities/seaside", tagline: "North Oregon Coast expedited passport processing", highlights: ["Seaside & Cannon Beach coverage", "Serving Gearhart, Astoria, Tillamook"], badge: null, status: "live" },
  { name: "Lincoln City", route: "/cities/lincoln-city", tagline: "Lincoln County emergency & expedited passport services", highlights: ["Lincoln City & central coast coverage", "Serving Newport, Depoe Bay, McMinnville"], badge: null, status: "live" },
  { name: "Newport", route: "/cities/newport-or", tagline: "Lincoln County emergency & expedited passport services", highlights: ["Newport & Lincoln County south coverage", "Serving Toledo, Waldport, Yachats"], badge: null, status: "live" },
  { name: "Tillamook", route: "/cities/tillamook", tagline: "Tillamook County emergency & expedited passport services", highlights: ["Tillamook & coastal dairy country coverage", "Serving Rockaway Beach, Garibaldi, Manzanita"], badge: null, status: "live" },
  { name: "Redmond", route: "/cities/redmond", tagline: "Central Oregon emergency & expedited passport services", highlights: ["Redmond & RDM airport coverage", "Serving Bend, Sisters, Prineville, Madras"], badge: null, status: "live" },
  { name: "Prineville", route: "/cities/prineville", tagline: "Crook County emergency & expedited passport services", highlights: ["Prineville & Ochoco Mountains rural coverage", "Serving Powell Butte, Post, Redmond, Bend"], badge: null, status: "live" },
  { name: "Hermiston", route: "/cities/hermiston", tagline: "Umatilla County emergency & expedited passport services", highlights: ["Hermiston & Tri-Cities WA coverage", "Serving Pendleton, Boardman, Stanfield, Umatilla"], badge: null, status: "live" },
  { name: "McMinnville", route: "/cities/mcminnville", tagline: "Yamhill County wine country passport services", highlights: ["McMinnville area coverage", "Serving Newberg, Sheridan"], badge: null, status: "live" },
  { name: "Keizer", route: "/cities/keizer", tagline: "Marion County northern Salem passport services", highlights: ["Keizer area coverage", "Serving Salem, Woodburn"], badge: null, status: "live" },
  { name: "Woodburn", route: "/cities/woodburn", tagline: "Marion County expedited passport processing", highlights: ["Woodburn area coverage", "Serving Salem, Hubbard"], badge: null, status: "live" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function OregonCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Oregon Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Oregon Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Oregon</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Oregon locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}